import { ErrorMessage, ErrorTypeCommon } from '@/interfaces/ErrorCodeSignature/ErrorCode';

export const getErrorCodes = (errorCode: ErrorTypeCommon) => {
  switch (errorCode) {
    case ErrorTypeCommon.ESG0014:
      return ErrorMessage.ESG0014;
    case ErrorTypeCommon.ESG0015:
      return ErrorMessage.ESG0015;
    case ErrorTypeCommon.ESG0016:
      return ErrorMessage.ESG0016;
    default:
      return 'Error desconocido';
  }
};
